// AdminRoute.tsx
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUserGroups } from '../utils/AuthUtils'

interface AdminRouteProps {
  children: JSX.Element;
  fallbackPath?: string;
}

const AdminRoute = ({ children, fallbackPath = "/staff/unauthorized" }: AdminRouteProps) => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    getUserGroups()
      .then((groups) => setIsAdmin(groups.includes('Administrators')))
      .catch(() => setIsAdmin(false));
  }, []);

  if (isAdmin === null) return <div>Loading...</div>;
  if (!isAdmin) return <Navigate to={fallbackPath} replace />;

  return children;
};

export default AdminRoute;
